import React, {useEffect} from "react";
import "./complaint.css";
import Chatheader from "../chatheader/chatheader";
import TextField from '@material-ui/core/TextField';
import { useNavigate } from "react-router-dom";
import { useStateValue } from '../../../../stateprovider'

const ComplaintSubmit = () => {
    const [{ appnav }, dispatch] = useStateValue();
    useEffect(()=>{
        dispatch({
            type: "APP_NAV_STATE",
            appnav: true
        });
    }, [])
    const navigate = useNavigate();
    return <div className="app_complaint">
        <Chatheader />
        <div className="app_complaint_container">
            <div className="app_complaint_text">
                <h1>Welcome! Tambore</h1>
                <p>Hang In There, We will connect you to a Doctor
                    shortly, kindly fill the information below.</p>
            </div>
            <div className="app_complaint_textbox">
                <TextField
                    className='fav_complaintbox'
                    id="standard-multiline-flexible"
                    label={<>Tell us why you want to speak to a Doctor
                        <p>(Please include the sympthoms and when the symptoms started)</p></>}
                    multiline
                    maxRows={4}
                    variant="standard"
                // onChange={e => setComplaint(e.target.value)}
                />
            </div>
            <button className="app_buttondisabled"
             onClick={()=> navigate("/payment")}
             >Submit Complaints</button>
        </div>

    </div>
}
export default ComplaintSubmit;